import RatingStore from './store'
import { rating as config } from '../config'

export const store = new RatingStore(config)



// WEBPACK FOOTER //
// ./src/rating/index.js